/* eslint-disable
 max-statements-per-line,
 no-eq-null,
 */
import angular from 'angular'
import has from 'lodash/has'
import set from 'lodash/set'
import reduce from 'lodash/reduce'
import _ from 'lodash'

export default ErrorCatcher

/** @ngInject */
function ErrorCatcher($state, $stateParams, $timeout, $cookies, NavError) {
    const removeField = function (obj, path) {
        if (has(obj, path)) {
            return set(obj, path, undefined)
        }
        return obj
    }
    const removeFields = (paths) => (obj) => reduce(paths, removeField, obj)
    const removeErrorFields = removeFields([
        'config.transformRequest',
        'config.transformResponse',
        'config.headers',
        'config.data.password',
        'config.data.passwordCheck',
    ])

    const catchError = (bypassRedirectToLogin) => function (errorResult) {
        // Remove $promise and $resolved from angular promise object
        const error = JSON.parse(angular.toJson(errorResult))

        // Print error in browser console
        console.error('ErrorCatcher', error)

        // Send error to the server
        NavError
        .sendError({
            state: window.location.pathname,
            url: (error.config != null ? error.config.url : 'no url'),
            returnCode: error.status,
            error: _.assign({}, { idRequest: _.get(_.get(errorResult, 'headers', _.noop)(), 'x-urg-id-req') }, removeErrorFields(error)),
        })
        .$promise
        .catch((error) => console.error('Cannot send error logging to the server', error))

        // Redirect to login in case of not authenticated
        if (!bypassRedirectToLogin && (error.status === 401)) {
            $cookies.remove('ssoStatus', { path: '/' })
            return $timeout(() => $state.go('login', { redirectTo: $state.current.name, bulk_purchase: $stateParams.bulk_purchase }, { reload: true }))
        }
    }

    return {
        WEBSITE_ERROR_STATUS: 0,
        catchError: catchError(false),
        catchErrorWithoutRedirect: catchError(true),
    }
}



// WEBPACK FOOTER //
// ./src/services/errorcatcher/errorcatcher.js